module.exports = __webpack_public_path__ + "static/img/quan_3.f1a05589.png";